import { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { CustomModal } from "components";
import CustomButton from "components/CustomButton";
import { Row, Col } from "antd";

function CropImg({ imgURL, visible, handleClose, handleSubmit, aspectRatio }) {
  const cropperRef = useRef(null);
  const [croppedImg, setCroppedImg] = useState("");
  const [cropper, setCropper] = useState();
  const [selectedAspect, setSelectedAspect] = useState(aspectRatio);
  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    setCroppedImg(cropper.getCroppedCanvas().toDataURL());
  };

  useEffect(() => {
    cropper?.setAspectRatio(aspectRatio);
  }, [aspectRatio, cropper]);

  return (
    <CustomModal
      visible={visible}
      handleClose={handleClose}
      handleSubmit={() => {
        handleSubmit({ src: croppedImg, isUpdated: true, loading: false });
        handleClose();
      }}
    >
      <Cropper
        style={{ height: 450, width: "100%" }}
        src={imgURL}
        initialAspectRatio={aspectRatio}
        viewMode={2}
        guides={true}
        dragMode="move"
        crop={onCrop}
        ref={cropperRef}
        onInitialized={(instance) => {
          setCropper(instance);
        }}
      />
      <Row gutter={16} justify="space-between" style={{ padding: "10px" }}>
        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(16 / 10);
              setSelectedAspect(16 / 10);
            }}
            btntext="16 / 10"
            styles={{ backgroundColor: selectedAspect === 16 / 10 && "orange" }}
          />
        </Col>

        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(16 / 9);
              setSelectedAspect(16 / 9);
            }}
            btntext="16 / 9"
            styles={{ backgroundColor: selectedAspect === 16 / 9 && "orange" }}
          />
        </Col>

        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(4 / 3);
              setSelectedAspect(4 / 3);
            }}
            btntext="4 / 3"
            styles={{ backgroundColor: selectedAspect === 4 / 3 && "orange" }}
          />
        </Col>

        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(1);
              setSelectedAspect(1 / 1);
            }}
            btntext="1 / 1"
            styles={{ backgroundColor: selectedAspect === 1 / 1 && "orange" }}
          />
        </Col>

        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(2 / 1);
              setSelectedAspect(2 / 1);
            }}
            btntext="2 / 1"
            styles={{ backgroundColor: selectedAspect === 2 / 1 && "orange" }}
          />
        </Col>

        <Col>
          <CustomButton
            onClick={() => {
              cropper?.setAspectRatio(NaN);
              setSelectedAspect(-1);
            }}
            btntext="Free"
            styles={{ backgroundColor: selectedAspect === -1 && "orange" }}
          />
        </Col>
      </Row>
    </CustomModal>
  );
}

export default CropImg;
